/**
 * `LinkAuthFlowWebview` is a wrapper component around `anchor tag`.
 *
 * @param {Object} props - The properties object.
 * @param {('signIn', 'signUp')} [props.modalType] - Type of modal triggered in webviews like sign up or sign in.
 * @param {string} [props.target='_top'] - The target frame for the link. Default is '_top'.
 * @param {string|JSX.Element} props.children - The text or elements to be rendered within the link.
 *
 * @returns {JSX.Element} The rendered JSX element.
 */
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './LinkAuthFlowWebview.module.css';

const productNameMap = {
  pro: 'premium',
  investingClub: 'investingClub',
  registeredOnly: 'registeredOnly',
  plus: 'plus',
};

const LinkAuthFlowWebview = (props) => {
  const {
    windowTopLocationHref,
    style,
    product,
    modalType,
    className,
    children,
    target,
  } = props;

  // get origin from href
  const origin = new URL(windowTopLocationHref).origin;

  const productName = productNameMap[product] || 'none';

  let hrefUrl;
  // webview auth flow needs to update the href with correct url and product to initiate mobile auth flow
  switch (modalType) {
    case 'signIn':
      hrefUrl = `${origin}/mobileapps:sign-in:` + productName;
      break;
    case 'signUp':
      hrefUrl = `${origin}/mobileapps:sign-up:` + productName;
      break;
  }

  return (
    <a
      href={hrefUrl}
      target={target}
      className={cx(styles.link, className)}
      style={style}
    >
      {children}
    </a>
  );
};

LinkAuthFlowWebview.displayName = 'LinkAuthFlowWebview';

LinkAuthFlowWebview.propTypes = {
  target: PropTypes.string,
  children: PropTypes.node,
  product: PropTypes.string,
  className: PropTypes.string,
  modalType: PropTypes.string,
  windowTopLocationHref: PropTypes.string,
  style: PropTypes.object,
};

LinkAuthFlowWebview.defaultProps = {
  target: '_top',
  children: null,
  product: '',
  className: '',
  modalType: '',
  windowTopLocationHref: '',
  style: {},
};

export default LinkAuthFlowWebview;
